<template>
    <div class="algolia-listing-product-block__sale-banner-wrapper">
        <div
            class="algolia-listing-product-block__sale-banner"
            :style="{backgroundColor: actionLabel.label_color}"
            :class="displayLabel"
        >
            <span class="algolia-listing-product-block__sale-banner-text" :class="{
                'algolia-listing-product-block__sale-banner-text--default': actionLabel.label_text_size === 'default',
                'algolia-listing-product-block__sale-banner-text--large': actionLabel.label_text_size === 'large'
            }" v-text="actionLabel.label_text"></span>
        </div>
        <div :style="{borderColor: `transparent ${actionLabel.label_color} transparent transparent`}"
            class="algolia-listing-product-block__sale-banner-triangle"></div>
    </div>
</template>

<script>
export default {
    name: "ActionLabel",
    props: {
        actionLabel: {
            type: [Boolean, Object],
            required: true,
        }
    },
    computed: {
        displayLabel() {
            let className;

            if(this.actionLabel.label_visibility === 'desktop_only') {
                className = "algolia-listing-product-block__sale-banner--desktop-only"
            }  else if (this.actionLabel.label_visibility === 'mobile_only') {
                className = "algolia-listing-product-block__sale-banner--mobile-only"
            }
            return className;
        }
    }
};
</script>
